import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://eruohfriuwytkfzdcknr.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVydW9oZnJpdXd5dGtmemRja25yIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDA3NzI3MjYsImV4cCI6MjA1NjM0ODcyNn0.wmu6iiPLnBWvDz6Hpdz88Xh2TgMitra-xrFqr3sf_W4';
const supabaseServiceKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVydW9oZnJpdXd5dGtmemRja25yIiwicm9sZSI6InNlcnZpY2Vfcm9sZSIsImlhdCI6MTc0MDc3MjcyNiwiZXhwIjoyMDU2MzQ4NzI2fQ.i2pD813tTnbHZurxleoueACllJkIO6BJ4M2H5FZlLJU';

// Regular client for most operations
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true, // This is important for the password reset flow
  }
});

// Admin client with service role key for operations that need to bypass RLS
export const supabaseAdmin = createClient(supabaseUrl, supabaseServiceKey, {
  auth: {
    persistSession: false
  }
});

// Helper function to check if email is from allowed domain
export const isAllowedDomain = (email: string) => {
  return email.endsWith('@dicomexpress.com');
};

// Auth helper functions
export const signInWithGoogle = async () => {
  const { data, error } = await supabase.auth.signInWithOAuth({
    provider: 'google',
    options: {
      queryParams: {
        hd: 'dicomexpress.com' // Restrict to Dicom Express domain
      }
    }
  });

  if (error) throw error;
  return data;
};

export const signOut = async () => {
  const { error } = await supabase.auth.signOut();
  if (error) throw error;
};

export const getCurrentUser = async () => {
  const { data: { user }, error } = await supabase.auth.getUser();
  if (error) throw error;
  return user;
};

export const onAuthStateChange = (callback: (user: any) => void) => {
  return supabase.auth.onAuthStateChange((event, session) => {

    callback(session?.user || null);
  });
}; 